/* eslint-disable prefer-const */
/* eslint-disable no-undef */
import React, { useEffect, useRef, useState } from 'react'
import api from '../../../api/stoty'
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Grid, Typography } from '@material-ui/core/'
import { setScrollActive } from '../../../modules/audio/actions'
import moment from 'moment'
import Audio from '../PlayerPodcast'
import audioItem from '../../../assetss/img/audioItem.svg'
import ModalPodcast from '../ModalPodcast'
import listenIconPodcast from '../../../assetss/img/listenIconPodcast.svg'
import './index.scss'

const CardPodcast = ({ data, setPlay, play, audioElement, audioProps, setSrcAudio, srcAudio, executeScroll }) => {
  const audioRef = useRef(null)
  const [playAudio, setPlayAudio] = useState(false)
  const dispatch = useDispatch()
  const { user } = useSelector(({ session }) => session)
  const { audioState } = useSelector(({ audio }) => audio)
  const { id } = useParams()
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (data?.uuid === id) {
      executeScroll(audioRef)
    }
  }, [id])

  useEffect(() => {
    if (data?.podcast?.src === audioState?.src) {
      window?.addEventListener('scroll', scrollHandler, true)
    }
    return function () {
      window.removeEventListener('scroll', scrollHandler, true)
    }
  }, [audioState])

  const scrollHandler = e => {
    dispatch(setScrollActive({
      activeScroll: {
        offsetTop: audioRef?.current?.offsetTop,
        offsetHeight: audioRef?.current?.offsetHeight,
      },
    }))
  }

  const countLike = () => {
    let count = data?.podcast?.listenCountByLoggedIn + data?.podcast?.listenCountByNotLoggedIn + data?.podcast?.listenCountDefault || '0'

    return count
  }

  const checkedPodcast = () => {
    api.isCheckedPodcast(audioState?.podcast?.podcast?.uuid, user?.accessKey)
      .then(res => {
        if (data?.podcast?.uuid === audioState?.podcast?.podcast?.uuid) {
          setOpen(!res?.data?.exists)
        }
      })
      .catch(error => console.error(error))
  }

  return (
    <>
      <ModalPodcast
        isOpen={open}
        setOpen={setOpen}
        idPodcast={audioState?.podcast?.podcast?.uuid}
      />

      <Grid ref={audioRef} className='cardPodcast' id='ffffff'>
        <Grid className='listenBoxAudio'>
          <img className='iconAudio' src={audioItem} alt='audio' /> Podcast
        </Grid>
        <img className='imgPodcast' src={data?.image?.src} />
        <Typography className='titlePodcast'>{data?.title}</Typography>
        <Grid className='audioBox'>
          <Audio
            audioElement={audioElement}
            audioProps={audioProps}
            play={play} setPlay={setPlay}
            audio={data?.podcast?.src}
            setPlayAudio={setPlayAudio}
            playAudio={playAudio}
            idCard={data?.uuid}
            setSrcAudio={setSrcAudio}
            srcAudio={srcAudio}
            podcastData={data}
            checkedPodcast={checkedPodcast}
          />
        </Grid>
        <Grid className='hashtagsBox'>{data?.hashtags?.map(item => <span key={item}>{item}</span>)}</Grid>
        <Grid className='footerPodcast'>
          <Typography className='datePosted'>
            Posted on {moment(+data?.createdAt)?.format('MMMM, D, h:mm A')}<br />
            by tellMe
          </Typography>
          <Typography className='fullCountLike'>
            <img src={listenIconPodcast} /> {countLike()}
          </Typography>
        </Grid>
      </Grid>
    </>
  )
}

export default CardPodcast
